import { Card } from "materia"
import s from "./JourneyTeaser.module.scss"

export const JourneyTeaserSkeleton = () => {
  return (
    <Card>
      <div className={s.skeleton}>
        <div className={s.skeleton__title} />
        <div className={s.skeleton__status} />
      </div>
    </Card>
  )
}
